import type { TableColumnsType } from 'antd';
import type { TargetGroupType } from './TargetGroups.types.ts';
import * as Yup from 'yup';
import { HomeOutlined } from '@ant-design/icons';
import i18n from '../../utils/i18n.ts';
import { checkTargetGroup } from './TargetGroups.services.ts';

export const TARGET_GROUPS_FORM = 'TargetGroupsForm';

export const BREADCRUMBS = [
  {
    href: '/',
    title: <HomeOutlined />,
  },
  {
    href: '/',
    title: i18n.t('common.portal'),
  },
  {
    href: '/admin',
    title: i18n.t('pages.admin.title'),
  },
  {
    title: i18n.t('pages.admin.module.target-groups'),
  },
];

export const TARGET_GROUPS_COLUMNS: TableColumnsType<TargetGroupType> = [
  {
    title: i18n.t('pages.target-groups.name'),
    dataIndex: 'name',
  },
  {
    title: i18n.t('pages.target-groups.entra-group-name'),
    dataIndex: 'entraGroupName',
  },
  {
    title: i18n.t('pages.target-groups.active'),
    dataIndex: 'active',
    render: (value: string) => (value ? i18n.t('common.yes') : i18n.t('common.no')),
    width: 200,
  },
];

export const TARGET_GROUPS_FORM_SCHEMA = Yup.object().shape({
  name: Yup.string().required(i18n.t('error.validation.required-name')),
  entraGroup: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Entra ID is required'),
      }),
    )
    .min(1, i18n.t('error.validation.required-group'))
    .nullable()
    .required(i18n.t('error.validation.required-group'))
    .test('unique-group', i18n.t('error.validation.exist-group'), async (value) => {
      const isExist = await checkTargetGroup(value[0].value);
      return !isExist;
    }),
});

export const TARGET_GROUPS_INITIAL_FORM_VALUES = {
  id: '',
  name: '',
  entraGroup: null,
  active: false,
};
